import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AppRoutingModule } from '../.././app-routing.module';
import { HeaderComponent } from './header/header.component';
import { LayoutComponent } from './layout/layout.component';
import {TuiTabsModule} from '@taiga-ui/kit';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AppComponent } from 'src/app/app.component';
import { FooterComponent } from './footer/footer.component';
//import { AlertComponent } from './alert/alert.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Headertop5Component } from './headertop5/headertop5.component';

import { TuiLoaderModule, TuiNotificationsModule, TuiRootModule } from '@taiga-ui/core';
import { DemouserComponent } from './demouser/demouser.component';
import { Header1Component } from './header1/header1.component';
import { CounselorSignupComponent } from './counselor-signup/counselor-signup.component';
import { PaymentComponent } from './payment/payment.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

@NgModule({
  declarations: [LayoutComponent, HeaderComponent, FooterComponent, Headertop5Component, DemouserComponent, Header1Component, CounselorSignupComponent,PaymentComponent, ForgotPasswordComponent],
  imports: [FormsModule,
    CommonModule, AppRoutingModule,ReactiveFormsModule,
    ModalModule.forRoot(),TuiTabsModule,
    BsDropdownModule.forRoot(),
    CollapseModule.forRoot(),TuiNotificationsModule,TuiRootModule,TuiLoaderModule,
  ],
  exports : [LayoutComponent, HeaderComponent, FooterComponent,Headertop5Component],
  bootstrap: [AppComponent]
})
export class LayoutModule { 
  isCollapsed = true;
}
